import React,{useState,useEffect} from "react";
//import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import '../assets/css/all.css';
import '../assets/css/AdminDashboard.css';
import Nav from '../Nav.js';
import avtroute from "../img/route.png";
import avtcarpark from "../img/car-parking.png";
import avtcar from "../img/car.png";
import avtnosignal from "../img/no-signal.png";
import avtbarchart from "../img/bar-chart.png";
//import { Helmet } from "react-helmet";
import { aPIURL} from '../utils/common';
import axios from 'axios';
import PieChart from "./PieChart.js";
import SalesChart from "./SalesChart.js";
import { useNavigate  } from "react-router-dom";


/*
const handleLogout = () => {
  removeUserSession();
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<Login/>);    
}
*/
const AdminDashboard = () => {
   
    const history = useNavigate();
    let [parked, setParked] = useState(0);
    let [moving, setMoving] = useState(0);
    let [idle, setIdle] = useState(0);
    let [notUpdated, setNotUpdated] = useState(0);
    let [soldCount,setSoldCount]= useState(0);
    let [inventoryCount,setInventoryCount]= useState(0);
    let [unassignedCount,setUnassignedCount]= useState(0);
    let [holdCount,setHoldCount]= useState(0);
    let [reportID,setReportID]=useState(1);
    const API_URL=aPIURL();
    let items =  [1, 1, 1];    
    let [cdata, setCdata] = useState(items);   

    let slitems =  [1, 1, 1];    
    let [saleLabelData, setSaleLabelData] = useState(slitems);   
    let slditems =  [1, 1, 1];    
    let [saleCountData, setSaleCountData] = useState(slditems);   
    

    useEffect(() => 
    {
          ViewDashboardCount();
          
          ViewDashboardBelowDataCount();  

          ViewDashboardSaleDataCount(1);
 
    },[]);

    const changeReporttype = (e) => 
      {   
          setReportID(e.target.value)
          ViewDashboardSaleDataCount(e.target.value);
          
      }      
        const ViewDashboardCount=()=>
          {
                 const daurls=API_URL+`Dashboard/0`; 
                 
                 const response =  axios.get(daurls).then(response => 
                   {       
                         setMoving(response.data.data[0].moving);
                         setParked(response.data.data[0].parked);               
                         setIdle(response.data.data[0].idle);
                         setNotUpdated(response.data.data[0].notUpdated);
                         
                         if((response.data.data[0].moving+response.data.data[0].parked+response.data.data[0].notUpdated+response.data.data[0].idle)>0)
                          {
                            setCdata([response.data.data[0].moving+response.data.data[0].idle,response.data.data[0].parked,response.data.data[0].notUpdated]);                            
                          }
                          else
                          {
                            setCdata([0,0,0]);                     
                          }
             
                   }).catch(function(error) 
                    {
                         console.log(error.message);
                    });    
         
          }
          const ViewDashboardBelowDataCount=()=>
          {
              //setReportID
                   const bdaurls=API_URL+`AdminDashboardCount/`; 
                   
                   //alert(bdaurls);
                   const bresponse =  axios.get(bdaurls).then(bresponse => 
                     {      
                          setSoldCount(bresponse.data.data[0].soldCount);
                          setInventoryCount(bresponse.data.data[0].inventoryCount);
                          setUnassignedCount(bresponse.data.data[0].unassignedCount);
                          setHoldCount(bresponse.data.data[0].holdCount);                   
                                         
                     }).catch(function(error) 
                      {
                           console.log(error.message);
           
                     });    
           
          }
          const ViewDashboardSaleDataCount=(rID)=>
          {
                  const saleurls=API_URL+`AdminDashboardSaleDetailsCount/${rID}`; 
                  //alert(saleurls);
                  const bresponse =  axios.get(saleurls).then(slresponse => 
                       {      
                        if(rID==1)
                        {
                          setSaleLabelData([slresponse.data.data[0].salesData,slresponse.data.data[1].salesData,slresponse.data.data[2].salesData,slresponse.data.data[3].salesData,slresponse.data.data[4].salesData,slresponse.data.data[5].salesData,slresponse.data.data[6].salesData]);
                          setSaleCountData([slresponse.data.data[0].sCount,slresponse.data.data[1].sCount,slresponse.data.data[2].sCount,slresponse.data.data[3].sCount,slresponse.data.data[4].sCount,slresponse.data.data[5].sCount,slresponse.data.data[6].sCount]);
                          console.log(slresponse.data);   
                        }
                        else
                        {
                             setSaleLabelData([slresponse.data.data[0].salesData,slresponse.data.data[1].salesData,slresponse.data.data[2].salesData,slresponse.data.data[3].salesData,slresponse.data.data[4].salesData,slresponse.data.data[5].salesData]);
                             setSaleCountData([slresponse.data.data[0].sCount,slresponse.data.data[1].sCount,slresponse.data.data[2].sCount,slresponse.data.data[3].sCount,slresponse.data.data[4].sCount,slresponse.data.data[5].sCount]);
                             console.log(slresponse.data);                     
                        }                                           
                      }).catch(function(error) 
                      {
                             console.log(error.message);             
                      });                 
              }
              const GoToPage = (e) => 
                {
                  history(e); 
                };
              

return (
	<>
  {/*
<Helmet>
     <script type="text/javascript">
                  window.loaddashboard();           
     </script>
</Helmet>*/}
<div className="top-bar clearfix">
        <div className="row">
          <div className="col-xs-12">
            <h2> Dashboard </h2>
          </div>
        </div>
      </div>

      <div className="container-fluid p-3">
    <div class="card mb-3 shadow no-border border-0">
    <div class="card-body">      
        <div className="row">
          <div className="col-lg-5">
            <div className="row">
              <div className="col-12 col-sm-6">
                <div className="card form-group">
                  <div className="card-body">
                    <h6 className="text-center">Vehicle Status</h6>
                    <PieChart items={cdata}/> 
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6">
                <div className="card form-group">
                  <div className="card-body dash-block d-flex align-items-center flex-column" > <img src={avtcar} alt="Vehicle"/> 
                  <span className="num" ><b><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminVehicles") }>{moving+idle+parked+notUpdated}</a> </b></span>
                    <h6><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminVehicles") }>All Vehicle</a></h6>
                   </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="row">
              <div className="col-12 col-sm-6 col-md-4">
                <div className="card form-group">
                  <div className="card-body dash-block d-flex align-items-center flex-column"> <img src={avtroute} alt="Moving"/> 
                  <span className="num text-success"><b><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminVehicles") }>{moving+idle}</a></b></span>
                    <h6 className="text-success"><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminVehicles") }>Moving</a></h6>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4">
                <div className="card form-group">
                  <div className="card-body dash-block d-flex align-items-center flex-column"> <img src={avtcarpark} alt="Parking"/> 
                  <span className="num text-warning"><b><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminVehicles") }>{parked}</a></b> </span>
                    <h6 className="text-warning"><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminVehicles") }>Parked</a> </h6>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4">
                <div className="card form-group">
                  <div className="card-body dash-block d-flex align-items-center flex-column"> <img src={avtnosignal} alt="Not Updating"/> 
                  <span className="num text-danger"><b><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminVehicles") }>{notUpdated}</a></b></span>
                    <h6 className="text-danger"><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminVehicles") }>No Network</a> </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="card form-group">
              <div className="card-body p-0">
                <div className="row g-0 statusBlock">                  
                  <div className="col-6 d-flex align-items-center flex-column justify-content-center p-4 border-bottom">
                    <h5 className="text-success"><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminDevices") }>{soldCount}</a></h5>
                    <p className="m-0"><small><i className="fa-solid fa-check text-success"></i> </small> <a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminDevices") }><b>Sold </b>(Enabled)</a></p>
                  </div>
                  <div className="col-6 d-flex align-items-center flex-column justify-content-center p-4 border-bottom border-start">
                    <h5 className="text-muted"><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminDevices") }>{inventoryCount}</a></h5>
                    <p className="m-0"><small><i className="fa-light fa-xmark text-danger"></i> </small> <b><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminDevices") }>In Stock</a></b></p>
                  </div>
                  <div className="col-6 d-flex align-items-center flex-column justify-content-center p-4">
                    <h5 className="text-info"><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminDevices") }>{unassignedCount}</a></h5>
                    <p className="m-0"><small><i className="fa-solid fa-check text-info"></i> </small><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminDevices") }> <b>Unassigned </b>(Return From Customer)</a></p>
                  </div>
                  <div className="col-6 d-flex align-items-center flex-column justify-content-center p-4 border-start">
                    <h5 className="text-danger"><a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminDevices") }>{holdCount}</a></h5>
                    <p className="m-0"><small><i className="fa-light fa-xmark text-danger"></i> </small> <a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminDevices") }><b>Hold </b>(Payment Pending)</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="row">
              <div className="col-12 col-md-8">
              <div className="card form-group">
              <div className="card-body">
                  <select className="form-control"  name="reportType" value={reportID} onChange={changeReporttype} >
                  <option value={0}>Select Type</option>
                  <option value={1}>Weekly (Last 7 Days Sales)</option>
                  <option value={2}>Monthly (Last 6 Months Sales)</option>
                  <option value={3}>Yearly (Last 6 Years Sales)</option>
                  </select>
                  <SalesChart sditems={saleLabelData} saleitems={saleCountData}/>
                  </div></div>                  
              </div>
              <div className="col-12 col-md-4">
                <div className="card form-group">
                  <div className="card-body dash-block d-flex align-items-center flex-column" style={{minHeight:"365px"}} > <img src={avtbarchart} alt="Not Updating"/>
                  <a style={{ cursor:"pointer"}} onClick={()=>GoToPage("/AdminVehHistory") }> <h6>Vehicle History</h6></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div></div></div>
        
    </>
    );  
};

export default AdminDashboard;